import { Component, OnDestroy, OnInit, signal } from '@angular/core';

import { PessoaDetalhe } from '@/shared/components/pessoa/pessoa-detalhe/pessoa-detalhe';
import { DadosGeraisPrestador } from '@/features/registro/prestadores/dashboard-prestadores/components/dados-gerais-prestador/dados-gerais-prestador';
import { DocumentosPrestador } from '@/features/registro/prestadores/dashboard-prestadores/components/documentos-prestador/documentos-prestador';
import { DiretoriaPrestador } from '@/features/registro/prestadores/dashboard-prestadores/components/diretoria-prestador/diretoria-prestador';
import { CorpoSocietarioPrestador } from '@/features/registro/prestadores/dashboard-prestadores/components/corpo-societario-prestador/corpo-societario-prestador';
import { ComposicaoPrestador } from '@/features/registro/prestadores/dashboard-prestadores/components/composicao-prestador/composicao-prestador';
import { PsmtPrestador } from '@/features/registro/prestadores/dashboard-prestadores/components/psmt-prestador/psmt-prestador';
import { ServicosEspecialidadesPrestador } from '@/features/registro/prestadores/dashboard-prestadores/components/servicos-especialidades-prestador/servicos-especialidades-prestador';
import { ComissaoEticaPrestador } from '@/features/registro/prestadores/dashboard-prestadores/components/comissao-etica-prestador/comissao-etica-prestador';
import { RecursosHumanosPrestador } from '@/features/registro/prestadores/dashboard-prestadores/components/recursos-humanos-prestador/recursos-humanos-prestador';
import { RecursosMaterialsPrestador } from '@/features/registro/prestadores/dashboard-prestadores/components/recursos-materiais-prestador/recursos-materiais-prestador';
import { AtividadesPrestador } from '@/features/registro/prestadores/dashboard-prestadores/components/atividades-prestador/atividades-prestador';
import { GeridasPrestador } from '@/features/registro/prestadores/dashboard-prestadores/components/geridas-prestador/geridas-prestador';
import { GestaoGeridasPrestador } from '@/features/registro/prestadores/dashboard-prestadores/components/gestao-geridas-prestador/gestao-geridas-prestador';
import { AnotacoesPrestador } from '@/features/registro/prestadores/dashboard-prestadores/components/anotacoes-prestador/anotacoes-prestador';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { combineLatest, filter, Subscription } from 'rxjs';
import { Contato } from '@/shared/components/contato/contato';
import { Empty } from '@/shared/components/layout/empty/empty';
import { Pesquisa } from '@/shared/components/pessoa/pesquisa/pesquisa';
import { CustomClass } from '@/shared/classes/custom.class';
import { PermissionService } from '@/core/permissions/permission.service';
import { PERMISSOES } from '@/core/permissions/permissoes.catalog';
import { PessoaDomain } from '@/core/api/sicom-api/registro/pessoa/pessoa.domain';
import { normalizarTipoPessoa } from '@/shared/utils/pessoa-tipo.util';
import {
    COMISSOES_FINANCEIRO_RETURN_CONTEXT_ID,
    COMPOSICAO_FINANCEIRO_RETURN_CONTEXT_ID,
    DIRETORIA_FINANCEIRO_RETURN_CONTEXT_ID,
    SERVICOS_FINANCEIRO_RETURN_CONTEXT_ID
} from '@/features/registro/prestadores/dashboard-prestadores/components/prestador-financeiro-navigation.service';
import { ReturnRouteService } from '@/core/services/return-route.service';
import { PSMT_FINANCEIRO_RETURN_CONTEXT_ID } from '@/features/registro/prestadores/dashboard-prestadores/components/psmt-prestador/psmt-prestador-financeiro-navigation.service';
import { CORPO_SOCIETARIO_FINANCEIRO_RETURN_CONTEXT_ID } from '@/features/registro/prestadores/dashboard-prestadores/components/corpo-societario-prestador/corpo-societario-financeiro-navigation.service';
import { ABRIR_PRESTADOR_RETURN_CONTEXT_ID } from '@/features/registro/prestadores/dashboard-prestadores/components/prestador-abertura-navigation.service';

@Component({
    selector: 'app-dashboard-prestadores',
    standalone: true,
    imports: [
        PessoaDetalhe,
        DadosGeraisPrestador,
        DocumentosPrestador,
        DiretoriaPrestador,
        CorpoSocietarioPrestador,
        ComposicaoPrestador,
        PsmtPrestador,
        ServicosEspecialidadesPrestador,
        ComissaoEticaPrestador,
        RecursosHumanosPrestador,
        RecursosMaterialsPrestador,
        AtividadesPrestador,
        GeridasPrestador,
        GestaoGeridasPrestador,
        AnotacoesPrestador,
        Contato,
        Empty,
        Pesquisa
    ],
    templateUrl: './dashboard-prestadores.html',
    styleUrl: './dashboard-prestadores.scss'
})
export class DashboardPrestadores extends CustomClass implements OnInit, OnDestroy {
    protected readonly PERMISSOES = PERMISSOES;
    private routeSub: Subscription | undefined;
    private routerSub: Subscription | undefined;
    selectedComponent: string | null = null;
    pesquisarDialog = signal<boolean>(false);

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private returnRouteService: ReturnRouteService,
        private permissionService: PermissionService
    ) {
        super();
    }

    ngOnInit(): void {
        this.routeSub = combineLatest([this.route.data, this.route.paramMap]).subscribe(([data, params]) => {
            this.selectedComponent = (data['codigo'] as string | undefined) ?? params.get('codigo') ?? this.defaultDaRaiz();
            this.restaurarPrestadorRetorno();
        });
        this.routerSub = this.router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd && event.urlAfterRedirects.startsWith('/prestadores'))).subscribe(() => {
            this.restaurarPrestadorRetorno();
        });
    }

    ngOnDestroy(): void {
        this.routeSub?.unsubscribe();
        this.routerSub?.unsubscribe();
    }

    showPesquisarPessoa = () => {
        this.pesquisarDialog.set(true);
    };

    /** Só carrega o módulo de prestador quando a pessoa é Prestador (Pré-Prestador é categoria própria e não carrega aqui). */
    isPrestadorSelecionado(): boolean {
        return normalizarTipoPessoa(this.pessoa()?.tipo) === 'PRESTADOR';
    }

    /**
     * Default de aba quando a raiz `/prestadores` não recebeu slug algum (nem `data.codigo`,
     * nem `paramMap.codigo`). Só cai em 'dados-gerais' se o usuário tiver a mesma permissão
     * exigida pela rota `prestadores/dados-gerais` — do contrário, retorna o sentinela vazio,
     * que o template trata como "nenhuma aba selecionada".
     */
    private defaultDaRaiz(): string {
        return this.permissionService.can(PERMISSOES.prestadores.dadosGerais.escopo) ? 'dados-gerais' : '';
    }

    private restaurarPrestadorRetorno(): void {
        // Fluxos financeiros: destino é /arrecadacao, então a restauração só ocorre ao voltar para /prestadores.
        for (const contextId of [
            PSMT_FINANCEIRO_RETURN_CONTEXT_ID,
            COMISSOES_FINANCEIRO_RETURN_CONTEXT_ID,
            CORPO_SOCIETARIO_FINANCEIRO_RETURN_CONTEXT_ID,
            COMPOSICAO_FINANCEIRO_RETURN_CONTEXT_ID,
            DIRETORIA_FINANCEIRO_RETURN_CONTEXT_ID,
            SERVICOS_FINANCEIRO_RETURN_CONTEXT_ID
        ]) {
            const pessoa = this.returnRouteService.consumirPayload<PessoaDomain>(contextId);
            if (pessoa?.id && pessoa.uf) {
                this.restaurarPrestador(pessoa);
                return;
            }
        }
        this.restaurarAberturaPrestador();
    }

    /**
     * Abrir-prestador é intra-módulo (destino também é /prestadores). Só restaura o prestador de
     * origem na perna de RETORNO — quando a URL atual é exatamente o `returnUrl` e não carrega
     * `returnContext` na query. Assim a ida (que também cai em /prestadores) e a troca de abas no
     * prestador aberto não disparam o "voltar".
     */
    private restaurarAberturaPrestador(): void {
        const contexto = this.returnRouteService.peek<PessoaDomain>(ABRIR_PRESTADOR_RETURN_CONTEXT_ID);
        if (!contexto) {
            return;
        }
        const url = new URL(this.router.url, 'http://sicom.local');
        if (url.searchParams.get('returnContext') || url.pathname !== contexto.returnUrl) {
            return;
        }
        const pessoa = this.returnRouteService.consumirPayload<PessoaDomain>(ABRIR_PRESTADOR_RETURN_CONTEXT_ID);
        if (pessoa?.id && pessoa.uf) {
            this.restaurarPrestador(pessoa);
        }
    }

    private restaurarPrestador(pessoa: PessoaDomain): void {
        const prestador = { ...pessoa, tipo: 'PRESTADOR' };
        this.pessoa.set(undefined);
        queueMicrotask(() => {
            this.atualizarPessoa(prestador);
        });
    }
}
